/*
 * @Author: Chao Yang
 * @Date: 2019-11-25 07:00:41
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-03-06 09:35:57
 */
import {
  AfterContentInit,
  Component,
  ContentChildren,
  Input,
  OnInit,
  TemplateRef
} from '@angular/core';
import { AlterDomusTemplateDirective } from '../alter-domus-template/alter-domus-template.directive';

@Component({
  selector: 'ad-splash-screen',
  templateUrl: './alter-domus-splash-screen.component.html',
  styleUrls: ['./alter-domus-splash-screen.component.scss']
})
export class AlterDomusSplashScreenComponent
  implements AfterContentInit, OnInit {
  messageTemplate: TemplateRef<any>;
  @ContentChildren(AlterDomusTemplateDirective)
  templates: AlterDomusTemplateDirective[];
  @Input()
  visible: boolean;

  constructor() {}

  ngAfterContentInit(): void {
    this.templates.forEach(item => {
      switch (item.getType()) {
        case 'message':
          this.messageTemplate = item.template;
          break;
      }
    });
  }

  ngOnInit(): void {}
}
